import { render, staticRenderFns } from "./manufacturingWithdrawals.vue?vue&type=template&id=ed4a54d4"
import script from "./manufacturingWithdrawals.vue?vue&type=script&lang=js"
export * from "./manufacturingWithdrawals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports